import { createContext } from "react";
import { Object3D } from "three";

export type PlayerContext = {
  player: Object3D;
};

export const playerContext = createContext<PlayerContext>(null!);
